/**
 * Normalizes an employee ID for submission to the API.
 *
 * Employee IDs come from Entra ID's onPremisesExtensionAttributes.extensionAttribute3
 * and are NOT always numeric - some are alphanumeric (e.g. "2GM000137"). Coercing them
 * with Number() turns those into NaN, which serializes to null in the request payload
 * and silently loses the value. Always send the raw trimmed string instead.
 *
 * Returns null when there is no usable value, so the API can reject it explicitly
 * rather than receiving an empty string.
 *
 * @param {unknown} value - raw attribute value (may be undefined/null/number/string)
 * @returns {string|null} trimmed string ID, or null when absent/blank
 */
export function toEmployeeId(value) {
  if (value === null || value === undefined) {
    return null;
  }

  const trimmed = String(value).trim();
  return trimmed === '' ? null : trimmed;
}

export default toEmployeeId;
